import type { ClientRecord } from "./clientApi";

export type ClientListItem = ClientRecord;

export type MatchReason = "name" | "contact" | "email" | "phone" | null;

export function clientMatch(client: ClientListItem, query: string): MatchReason {
  const needle = query.trim().toLocaleLowerCase();
  if (!needle) return null;
  if (client.displayName.toLocaleLowerCase().includes(needle)) return "name";
  if (client.primaryContact?.name.toLocaleLowerCase().includes(needle)) return "contact";
  if (client.primaryContact?.email?.toLocaleLowerCase().includes(needle)) return "email";
  if (client.primaryContact?.phone?.toLocaleLowerCase().includes(needle)) return "phone";
  return null;
}

export function filterClients(clients: ClientListItem[], query: string) {
  if (!query.trim()) return clients.map((client) => ({ client, reason: null as MatchReason }));
  return clients.flatMap((client) => {
    const reason = clientMatch(client, query);
    return reason ? [{ client, reason }] : [];
  });
}
